
import { Collapse } from '@material-ui/core';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import styled from 'styled-components';
import { Footer } from '../Components/Footer/Footer';
import { Database } from '../Managers/DataManager';
import { ProgramModel } from '../Models/Program.interface';
import { ProgramTabs}  from '../Components/ProgramTabs/ProgramTabs';
import { Image } from '../Components/Image/Image';
import { useContext } from 'react';
import { ProgramContext } from '../Context';
import { filter } from 'lodash';


const Banner = styled.img`
    width: 100%;
    object-fit: contain;
`


export const Program = () => {

    const [program, setProgram] = useState<ProgramModel>()

    let { id, name } = useParams<{id: string, name: string}>()

    const { programs } = useContext(ProgramContext)
    const leaving = new Subject<void>()
    console.log(id, name)
    useEffect(() => {
        if(!id) { return }
        Database.get(`program/${id}`)
        .then(obs => {
            obs.pipe(takeUntil(leaving))
            .subscribe(setProgram)
        })
        .catch(console.error)
        return () => leaving.next()
    }, [id])

    useEffect(() => {
        if(!name || !programs) { return }

        let program = filter(programs, prog => prog.name === name)?.[0]

        if(program){
            Database.get(`program/${program.id}`)
            .then(obs => {
                obs.pipe(takeUntil(leaving))
                .subscribe(setProgram)
            })
            .catch(console.error)
            return () => leaving.next()
        }


    }, [programs, name])

    return(
        <div style={{
            paddingTop: 100,
            backgroundColor: '#04060a'
        }}> 

            <Image src={program?.banner} alt="program banner" style={{width: "99.99vw",flex: 1, objectFit: "contain"}}/>

            <ProgramTabs program={program} mini={program?.id === 1} />

            <Footer />


        </div>
    )
}

